// The heart of the reframe: skills are one system with three kinds, each keyed
// to a phase of the meeting (pre-meeting cadence, live router, post-meeting
// notes delivery). Keep the three-kind framing in sync with the app's
// SkillLibrary sections and the FAQ.
const phases = [
  {
    badge: 'BEFORE',
    icon: '🗓️',
    title: 'Pre-meeting skills',
    fires: 'Run on a schedule against your calendar, through your own MCP server.',
    produces:
      'Your day’s meetings, pulled in ahead of time — each with an agenda Claude drafts from the invite and recent context.',
    example: '“Draft an agenda for every meeting on my calendar today.”',
  },
  {
    badge: 'DURING',
    icon: '🃏',
    title: 'In-meeting skills',
    fires: 'Watch the live transcript and fire the moment their “fires when…” hint matches.',
    produces:
      'Compact support cards, right when they’re relevant — the documented process, the devil’s advocate argument, the number you’d otherwise dig for.',
    example: '“Surface our pricing tiers when pricing comes up.”',
  },
  {
    badge: 'AFTER',
    icon: '📤',
    title: 'Post-meeting skills',
    fires: 'Run when the meeting ends — or on demand — against your own MCP servers.',
    produces:
      'The finished notes, delivered where your team already works: Notion, Linear, Slack, Obsidian, Google Drive.',
    example: '“Post the summary and action items to our Notion workspace.”',
  },
];

const SkillPhases = () => {
  return (
    <section className="skill-phases" id="skills">
      <div className="section-container">
        <p className="overline overline--center">ONE SKILL SYSTEM · THREE PHASES</p>
        <h2 className="section-title">Skills for before, during, and after</h2>
        <p className="section-subtitle">
          You teach Claude “meeting skills” in plain English by chatting with the built-in skills
          assistant. Each skill belongs to one phase of the meeting — and fires on its own, at the
          moment it can actually help.
        </p>

        <div className="skill-phases-grid">
          {phases.map((p, i) => (
            <div key={i} className="feature-card skill-phase-card">
              <span className="skill-phase-badge mono">{p.badge}</span>
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <div className="skill-phase-row">
                <span className="skill-phase-label mono">Fires</span>
                <p>{p.fires}</p>
              </div>
              <div className="skill-phase-row">
                <span className="skill-phase-label mono">Produces</span>
                <p>{p.produces}</p>
              </div>
              <p className="skill-phase-example">{p.example}</p>
            </div>
          ))}
        </div>

        <div className="meetings-note mono">
          Same chat, same “teach it once” idea — the app just knows whether a skill runs before,
          during, or after the meeting.
        </div>
      </div>
    </section>
  );
};

export default SkillPhases;
